<template>
  <div name="register_edit"  class="-mx-3 -mt-4">
    <section v-if="errored" class="w-full text-center mt-6">
      <h3 class="font-bold text-xl text-action-red">
        There was an issue adding the details.
      </h3>
      <p class="text-action-blue">
        Please try again shortly or contact us to resolve the issue.
      </p>
    </section>

    <form v-on:submit.prevent="processPupil" id="pupilForm" ref="form">
      <div class="grid grid-cols-1 space-y-1 py-4 border-b border-gray-300">
        <div class="mx-6">
          <label class="font-semibold"> Pupil Name *</label>

          <div class="mt-2 w-11/12 -ml-1">
            <input
              v-model="name"
              class="form-input focus:outline-none focus:bg-white focus:border-gray-500"
              id="grid-title"
              type="text"
              placeholder="Enter pupil name"
              required=""
            />
          </div>
          <p class="text-red-300 text-xs italic pt-1">
            Please fill out this field.
          </p>
        </div>
      </div>

      <div class="grid grid-cols-1 space-y-1 py-4 border-b border-gray-300">
        <div class="mx-6">
          <label class="font-semibold"> Gender *</label>

          <div class="mt-2 w-11/12 -ml-1">
            <ul class="buttons">
                     <li>
                       <button type="button" class="btn-outline-light btn-sm p-2"
                      v-bind:class="['male' == gender ? 'on' : '' ]"  @click="gender = 'male'"  > 
                          Male
                          </button>

                             <button type="button" class="btn-outline-light btn-sm p-2"
                      v-bind:class="['female' == gender ? 'on' : '' ]"  @click="gender = 'female'"  > 
                          Female
                          </button>
                        </li>
                      </ul>
          </div>
          <p class="text-red-300 text-xs italic pt-1">
            Please fill out this field.
          </p>
        </div>
      </div>

      <div class="grid grid-cols-1 space-y-1 py-4 border-b border-gray-300">
        <div class="mx-6">
          <label class="font-semibold"> Year Group *</label>

          <div class="mt-2 w-11/12 -ml-1">
            <ul class="buttons">
                     <li>
                       <button type="button" class="btn-outline-light btn-sm p-2" 
                       v-for="item in years" :key="item.id"
                      v-bind:class="[item.id == yearId ? 'on' : '' ]"  @click="yearId = item.id"  > 
                          {{ item.name }} 
                          </button>
                        </li>
                      </ul>
          </div>
          <p class="text-red-300 text-xs italic pt-1">
            Please fill out this field.
          </p>
        </div>
      </div>

      <div class="grid grid-cols-1 space-y-1 py-4 border-b border-gray-300">
        <div class="mx-6">
          <label class="font-semibold"> Class *</label>

          <div class="mt-2 w-11/12 -ml-1">
            <div class="mb-2">
              <dropdown :options="classDropdown" :selected="selectedClass" :width=24 v-on:updateOption="classSelect"></dropdown>

            </div>
                      
            <label>OR NEW Class <span class="text-xs text-red-400">(will overwright class dropdown selection)</span></label> <br/>
                          <input type="text" class="form-control" v-model="newClass" placeholder="New class name">
           
          </div>
          <p class="text-red-300 text-xs italic pt-1">
            Please fill out this field.
          </p>
        </div>
      </div>

      <div class="grid grid-cols-2 space-y-1 py-4 border-b border-gray-300">
        <div class="ml-6">
          <label class="font-semibold"> Ethnicity</label>

          <div class="mt-2 w-11/12 -ml-1">
            <input type="text" class="form-control" placeholder="Ethnicity" v-model="ethnicity">
          </div>
        </div>

        <div class="mr-6">
          <label class="font-semibold"> SEN</label>

          <div class="mt-2 w-11/12 -ml-1">
            <input type="text" class="form-control" placeholder="SEN" v-model="sen">
          </div>
        </div>
      </div>



                 <button
                  @click="submitForm()"
                 type="submit"
                class="
                  move-pupil-btn
                  publish-button
                  hover:opacity-75
                  mt-10
                  ml-8
                  w-8/12
                  mb-10
                "
                :disabled="isDisabled"
              >
              Save Pupil Details
              </button>


      </form>

  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'

import { BaseService } from "@/services/school.service";
import { yearGroupMixin} from "@/mixins/yearGroupMixin.js";


const dropdown = () => import('@/components/admin/Dropdown.vue')

export default {
  name: 'register_edit',
  mixins: [yearGroupMixin],
   props: {
    school: { type: Object, required: true },
    newAddition: Boolean,
    pupil: Object,
    schoolType: Object,
    classes: Array
    },
  computed: {
   // ...mapGetters({ currentUser: 'currentUser' }),
    isDisabled () {
       if ((this.selectedClass.id > 0 || this.newClass.length > 0) && this.name.length > 0) {
        return false
      } else {
        return true
      }
    },
    classDropdown () {
      var results = this.classes
      if (this.selectedClass === undefined) {
          this.selectedClass = results[0]
      }
      return results
    },
    componentLoaded () {
      return this.users.length > 0
    },
    title () {
      if (this.newAddition) {
        return "Add new Pupil"
      } else {
        return "Editing " + this.name
      }
    }
  },
  data () {
    return {
      loading: true,
      errored: false,
      hasPupilPremium: false,
      hasEAL: false,
      selectedClass: {},
      selectedOrg: {},
      types: [],
      years: [],
      sen: '',
      ethnicity: '',
      name: '',
      gender: 'male',
      yearId: 1,
      newClass: ''
    }
  },
  created() {
    if (this.newAddition == false) {
      if (this.pupil == undefined) {
        this.back()
        return
     } else {
      this.hasPupilPremium = this.pupil.premium_pupil === 0 || undefined ? false : true
      this.hasEAL = this.pupil.english_second === 0 || undefined ? false : true
      this.sen = this.pupil.sen_status === undefined ? '' : this.pupil.sen_status
      this.ethnicity = this.pupil.ethnicity == undefined ? '' : this.pupil.ethnicity
      this.name = this.pupil.name  == undefined ? '' : this.pupil.name
      this.gender = this.pupil.gender  == undefined ? 'male' : this.pupil.gender
      this.yearId = this.pupil.year.id == undefined ? 1 : this.pupil.year.id
      this.setClass()
     }
    }
  },
  mounted () {

  },
  methods: {
    cancel () {
      this.$router.push({ name: 'SchoolsAdmin'})
      window.scrollTo(0, 0);
    },

    submitForm () {

      if (this.$refs.form.requestSubmit === undefined) {
        this.processPupil();
      } else {
        this.$refs.form.requestSubmit();
      }
    },
    processPupil() {

      // values
      this.pupil.name = this.name
      this.pupil.gender = this.gender
      this.pupil.year_id = this.yearId
      if (this.newClass.length > 0) {
         this.pupil.inclass = this.newClass
       } else {
        this.pupil.inclass = this.selectedClass.name
       }
      
      this.pupil.english_second = this.hasEAL === "true" ? 1 : 0
      this.pupil.premium_pupil = this.hasPupilPremium === "true" ? 1 : 0
      this.pupil.ethnicity =  this.ethnicity;
      this.pupil.updated_at = new Date()
      this.pupil.sen_status = this.sen;

       if (this.pupil.identifier === undefined) {
        BaseService.create('archon/office/schools/'+ this.school.id  + '/pupils', this.pupil)
         .then(response => this.completion(false) )
        .catch((err) => {  this.failure(err) })

      } else {
        BaseService.update('archon/office/schools/'+ this.school.id  + '/pupils/' + this.pupil.identifier, this.pupil)
        .then(response => this.completion(false))
        .catch((err) => { this.failure(err)})
      }
    },
    setClass() {
       let t = this.classes
        .filter(tt => { return tt.name == this.pupil.inclass })
        .shift()
      this.selectedClass = t
    },
    updateCourseAddition (data) {
      this.course.id = data.id
      this.completion(true)
    },
    completion (reload) {
      this.back()
    },
    failure (error) {
       this.errored = true 
       console.log('Pupil update error ' + error);
    },
    classSelect (value) {
      this.selectedClass = value
    },
    // archive() {
    //     this.
    //     this.$http.update('schools/'+ this.school.id  + '/register/', this.pupil.identifier, this.pupil)
    //     .then(response => this.completion(false))
    //     .catch((err) => { this.failure(err)})
    // },
    deletion () {
          this.$swal({
        title: 'Are you sure you want to delete?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        cancelButtonCSS: 'cancelButton',
        confirmButtonText: 'Yes, remove pupil!',
                  customClass: {
            cancelButton: 'cancel-button-class',
          },
      }).then((result) => {
        if (result.value) {
          this.processDelete()
        }
      })    
    },
    processDelete () {
      this.$http.delete('schools/'+ this.school.id  + '/pupils/', this.pupil.identifier, null)
        .then(response => this.back())
        .catch(err => {
         console.log(err);
        });
    },
    updateOrg () {
       this.$swal({
        title: 'Are you sure you want to change?',
        text: "This will make the parent organisation different!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, change!',
                  customClass: {
            cancelButton: 'cancel-button-class',
          },
      }).then((result) => {
        if (result.value) {
          this.processOrg()
        }
      })    
    },
    back () {
      this.$emit('close')
    },
  },
  components: {
    dropdown,
  }
}
</script>

<style scoped>

.row {
  margin-bottom: 11px;
}

input[type="radio"] {
  margin: 12px !important;
  width: 2em;
  height: 2em;
  cursor: pointer;
}
.right {
  float: right;
}

a.back {
   cursor: pointer !important;
}

.options section:hover {
  cursor: pointer;
}

.btn-important {
  background-color: #F4AB64 !important;
  background-image: none;
}

.buttons {
  padding-left:0;
}



/*****************************
 **** Filter
 ***************************/

 ul.filter {
  width: 100%;
 }
 
  .filter li {
    width: 30%;
    padding-right: 0em !important;
      display: inline-block;
  }

  .filter li:first-of-type {
    width: 17%;
  }


  ul.buttons li  {
     display: inline-block;
  }

    ul.buttons li button {
      margin: 4px;
      border-width: 1px;
      cursor: pointer;
    }

    ul.buttons li button:hover {
      opacity: 0.7 !important;
    }

    ul.buttons li button.on {
       background-color: #e14eca !important;
       border-color: #e14eca !important;
       color: #fff;
    }

    
.form-control {
  display: block;
  width: 100%;
  height: calc(2.25rem + 2px);
  padding: 0.5rem 0.7rem;
  font-size: 0.875rem;
  line-height: 1.428571;
  color: rgba(255, 255, 255, 0.8);
  background-color: transparent;
  background-clip: padding-box;
  border: 1px solid #cad1d7;
  border-radius: 0.25rem;
  box-shadow: none;
  transition: all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

@media screen and (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}

.form-control::-ms-expand {
  background-color: transparent;
  border: 0;
}

.form-control:focus {
  color: rgba(255, 255, 255, 0.8);
  background-color: #ffffff;
  border-color: rgba(50, 151, 211, 0.25);
  outline: 0;
  box-shadow: none, none;
}

.form-control::placeholder {
  color: #adb5bd;
  opacity: 1;
}

.form-control:disabled,
.form-control[readonly] {
  background-color: #e9ecef;
  opacity: 1;
}

select.form-control:focus::-ms-value {
  color: rgba(255, 255, 255, 0.8);
  background-color: transparent;
}

.form-control-file,
.form-control-range {
  display: block;
  width: 100%;
}


</style>